export default __webpack_public_path__ + "static/media/spaceragga.83502481.jpg";